import store from "../../store/configure-store";
import { setBalanceValue, /* updateOnlyBalance, */ addToBalance } from "../../store/entities/balance-slice";
// Stari bet-slice više nije potreban; ukloni sve reference ako ih ima:
// import { setActiveBet } from "../../store/entities/bet-slice";
import { setCashout } from "../../store/entities/cashout-slice";
import { toggleFreeBetsState } from "../../store/entities/free-bets-state-slice";
import { setFreeTicketInfo } from "../../store/entities/freetickets/free-ticket-info-slice";
import { setInitialHitOdds } from "../../store/entities/hit-odds-slice";
import { setJackpotValue } from "../../store/entities/jackpot-slice";
import { setLoginData } from "../../store/entities/login-slice";
import { setAlreadyShownBonusModal, setBounsRoundsModal } from "../../store/entities/modals/bonus-rounds-modal-slice";
import { setPopupMessage } from "../../store/entities/popup-message-slice";
import { setServerMessage } from "../../store/entities/server-messages-slice";
import { shouldShowBonusModal } from "../bonuses/bounus-modal";
import { setsProperBonusLabel } from "../free-tickets/show-bonus-label";
import { setActiveBet } from "../../store/entities/bet-slice";
import gameDifficultyConverter from "../helpers/game-difficulty-helper";
import {
  upsertFromAck,
  markBallDone,
  remove as removePending,
} from "../../store/entities/pending-bets-slice";
import { tlog } from "../log";
import { setTurboMode } from "../../store/entities/turbo-mode-slice";
import { setTurboModeModal } from "../../store/entities/modals/turbo-mode-modal-slice";
import translate from "../translation/lang";
import { setBetHistoryList } from "../../store/entities/bet-history-slice";
import soundFxPlayer from "../audio/soundfx-player";

// na vrhu fajla:
let MINOR_FACTOR = 100; // default 2 dec
function setMinorFactorFromLogin(loginData) {
  const digits = loginData?.CompanyCurrencyData?.NumberOfDigits;
  if (Number.isInteger(digits) && digits >= 0 && digits <= 4) {
    MINOR_FACTOR = Math.pow(10, digits);
  } else {
    MINOR_FACTOR = 100; // fallback
  }
}

function toMinor(x) {
  const n = Number(x) || 0;
  return Math.round(n * MINOR_FACTOR);
}

function fromMinor(m) {
  const n = Number(m) || 0;
  return n / MINOR_FACTOR;
}

/**
 * PlinkoTransport
 * - Koordinator za bet_ack + ball_done (Model A: delta win primenjujemo tek kad lopta padne)
 */
class PlinkoTransport {
  constructor() {
    if (!PlinkoTransport.instance) {
      this.turboHold = false;     // da li je korisnik “drži” turbo
      this.turboPending = false;  // čekamo server potvrdu za poslednji item
      this.turboWatchdog = null;
      // TURBO: odloženi win-ovi po jedinstvenom UID-u "ticketId:seq"
      this.pendingTurboWins = new Map();   // key: "127258:1" -> Number(win_money)
      this.turboCounters   = new Map();    // key: ticket_id (Number) -> last seq (Number)
      this._turboDebug     = false;         // uključi/isključi debug logove
      this.turboRestart = null;        // { betAmount, rows, level }
      this.turboRestartForTicket = null; // da znamo za koji ticket smo tražili restart
      this.nextTurboStartValue = null;
      this.allowedTurboDrops = new Set(); // uid-evi za koje FE sme da animira drop
      this.turboAutoCashoutPending = false; // da ne šaljemo turbo_cashout više puta

      // rate limit iz login-a (ms) za turbo_bet_item
      this.turboBetSpeedLimitMs = 0;     // integer ms, 0 = no limit
      this.lastTurboItemSentAt = 0;      // Date.now() timestamp (poslednji SEND)
      this.turboRateTimer = null;        // timeout id za odloženi next

      // skup ticket-a koji su cashout-ovani na BE
      this.cashedOutTickets = new Set();

      // === NEW: live balls tracking (da ne cashout-ujemo dok lopte nisu u džepovima) ===
      this.liveTurboUids = new Set();            // Set<"ticketId:seq">
      this.liveTurboCountByTicket = new Map();   // Map<Number, Number>
      this.pendingEndTicketId = null;            // Number|null

      // lagani wrapper za logovanje
      this.dlog = (...args) => {
        if (this._turboDebug) {
          console.log("[TURBO/DBG]", ...args);
        }
      };

      // pomoćni ispis sadržaja mape (ključna stvar za dijagnostiku)
      this.debugListTurboWins = () => {
        const entries = Array.from(this.pendingTurboWins.entries())
          .map(([k, v]) => ({ uid: k, win: v }));
        this.dlog("pendingTurboWins size=", this.pendingTurboWins.size, entries);
        return entries;
      };

      PlinkoTransport.instance = this;
    }
    return PlinkoTransport.instance;
  }

  _requestTurboCashout(ticketId, { silent = true } = {}) {
    const st = store.getState();
    const sid = st.login?.sid;
    if (!sid || !ticketId) return;

    if (this.turboAutoCashoutPending) return;
    this.turboAutoCashoutPending = true;

    // prekini loop odmah
    this.turboHold = false;
    this.turboPending = false;
    this._clearTurboWatchdog();
    this._clearTurboRateTimer();
    this.clearTurboDropsForTicket(ticketId);

    if (!silent) {
      store.dispatch(setPopupMessage({
        message: translate("ending_turbo_mode") || "Ending Turbo mode...",
        delay: 2000,
      }));
    }

    store.dispatch({
      type: "WEBSOCKET_SEND",
      payload: ["turbo_cashout", { sid, ticketId }],
    });
  }

  allowTurboDrop(uid) {
    if (!uid) return;
    this.allowedTurboDrops.add(String(uid));

    // safety: da ne curi memorija ako se nešto “zaglibi”
    if (this.allowedTurboDrops.size > 5000) {
      // obriši najstarije na grubo (Set nema “pop first” direktno)
      const it = this.allowedTurboDrops.values();
      for (let i = 0; i < 1000; i++) {
        const n = it.next();
        if (n.done) break;
        this.allowedTurboDrops.delete(n.value);
      }
    }
  }

  consumeTurboDrop(uid) {
    const key = String(uid || "");
    if (!this.allowedTurboDrops.has(key)) return false;
    this.allowedTurboDrops.delete(key);
    return true;
  }

  clearTurboDropsForTicket(ticketId) {
    const prefix = `${Number(ticketId)}:`;
    for (const uid of Array.from(this.allowedTurboDrops)) {
      if (uid.startsWith(prefix)) this.allowedTurboDrops.delete(uid);
    }
  }

  setNextTurboStartValue(value) {
    const n = Number(value);
    this.nextTurboStartValue = Number.isFinite(n) ? n : null;
  }

  queueTurboRestart(data) {
    // data: { betAmount, rows, level }
    this.turboRestart = data || null;

    // zapamti trenutni ticketId (da restartujemo baš posle njegovog cashout-a)
    const st = store.getState();
    this.turboRestartForTicket = Number(st.turboMode?.ticketId) || null;
  }

  _clearTurboWatchdog() {
    if (this.turboWatchdog) {
      clearTimeout(this.turboWatchdog);
      this.turboWatchdog = null;
    }
  }

  _clearTurboRateTimer() {
    if (this.turboRateTimer) {
      clearTimeout(this.turboRateTimer);
      this.turboRateTimer = null;
    }
  }

  _armTurboWatchdog(ms = 5000) {
    this._clearTurboWatchdog();
    this.turboWatchdog = setTimeout(() => {
      // Nema odgovora dovoljno dugo → prekinuti burst, odlediti pending
      this.turboPending = false;
      this.turboHold = false;
      this.turboAutoCashoutPending = false;
      this._clearTurboRateTimer();
      store.dispatch(setPopupMessage({
        message: translate("server_timeout_please_try_again") || "Server timeout, please try again.",
        delay: 4000,
      }));
    }, ms);
  }

  // === HELPERI za cashout guard ===
  _uidToTicketId(uid) {
    if (typeof uid !== "string") return null;
    const t = Number(uid.split(":")[0]);
    return Number.isFinite(t) ? t : null;
  }

  // === NEW: live balls helpers (da end/cashout sačeka da lopte upadnu) ===
  _getLiveCountForTicket(ticketId) {
    const n = this.liveTurboCountByTicket.get(Number(ticketId)) || 0;
    return n > 0 ? n : 0;
  }

  _markTurboBallLive(uid) {
    const u = String(uid || "");
    if (!u.includes(":")) return;

    if (this.liveTurboUids.has(u)) return; // safety
    this.liveTurboUids.add(u);

    const tId = this._uidToTicketId(u);
    if (!Number.isFinite(tId)) return;

    const prev = this.liveTurboCountByTicket.get(tId) || 0;
    this.liveTurboCountByTicket.set(tId, prev + 1);
  }

  _markTurboBallDone(uid) {
    const u = String(uid || "");
    if (!this.liveTurboUids.has(u)) return; // nije označena kao live
    this.liveTurboUids.delete(u);

    const tId = this._uidToTicketId(u);
    if (!Number.isFinite(tId)) return;

    const prev = this.liveTurboCountByTicket.get(tId) || 0;
    const next = Math.max(0, prev - 1);
    if (next === 0) this.liveTurboCountByTicket.delete(tId);
    else this.liveTurboCountByTicket.set(tId, next);

    // ako čekamo end baš za ovaj ticket, probaj da završiš
    if (this.pendingEndTicketId != null && Number(this.pendingEndTicketId) === Number(tId)) {
      this._finalizePendingTurboEndIfReady(tId);
    }
  }

  _schedulePendingTurboEnd(ticketId) {
    const tId = Number(ticketId);
    if (!Number.isFinite(tId)) return;

    this.pendingEndTicketId = tId;

    // stopuj dalje slanje item-a
    this.turboHold = false;
    this.turboPending = false;
    this._clearTurboWatchdog();
    this._clearTurboRateTimer();

    // ako nema live lopti, završi odmah
    this._finalizePendingTurboEndIfReady(tId);
  }

  _finalizePendingTurboEndIfReady(ticketId) {
    const tId = Number(ticketId);
    if (!Number.isFinite(tId)) return;

    const live = this._getLiveCountForTicket(tId);
    if (live > 0) return; // još čekamo lopte

    // sada je bezbedno cashout
    this.pendingEndTicketId = null;
    this._requestTurboCashout(tId, { silent: true });
  }

  _clearPendingWinsForTicket(ticketId) {
    if (!Number.isFinite(ticketId)) return;
    for (const key of Array.from(this.pendingTurboWins.keys())) {
      if (this._uidToTicketId(key) === ticketId) {
        this.pendingTurboWins.delete(key);
      }
    }
  }

  turboStartHold() {
    this.turboHold = true;
    this._clearTurboRateTimer(); // u slučaju da je ostao neki zakazan next
    this._tryTurboNext();
  }

  turboStopHold() {
    this.turboHold = false;
    this._clearTurboRateTimer();
  }

  _tryTurboNext() {
    if (!this.turboHold) {
      console.log("[TURBO] skip: hold=false");
      return;
    }
    if (this.turboPending) {
      console.log("[TURBO] skip: pending=true");
      return;
    }

    const st = store.getState();

    const sid = st.login?.sid;
    const { ticketId, value } = st.turboMode || {};
    const betAmountRaw = st.betAmount;

    const rows = st.numberOfRows;
    const level = gameDifficultyConverter(st.gameDifficulty);

    // --- min/max čitanje (pokrivamo obe strukture koje se pojavljuju u kodu) ---
    const minBet =
      Number(
        st.login?.player_data?.company_currency_data?.min_bet ??
          st.login?.CompanyCurrencyData?.MinBet ??
          0
      ) || 0;

    const maxBet =
      Number(
        st.login?.player_data?.company_currency_data?.max_bet ??
          st.login?.CompanyCurrencyData?.MaxBet ??
          0
      ) || 0;

    const currency =
      st.login?.CurrencyID ||
      st.login?.player_data?.currency_code?.CurrencyID ||
      "";

    // --- stop uslovi koji nemaju veze sa validacijom ---
    if (!sid || !ticketId) return;

    // --- VALIDACIJA betAmount (prazno / 0 / NaN) ---
    const betAmount = Number(betAmountRaw);
    if (!Number.isFinite(betAmount) || betAmount <= 0) {
      this.turboHold = false;
      store.dispatch(
        setPopupMessage({
          message:
            (translate("invalid_bet_amount") || "Invalid bet amount.") +
            (minBet > 0 ? ` ${translate("min_bet_amount_is") || "Min bet amount is"} ${minBet} ${currency}` : ""),
          delay: 4000,
        })
      );
      return;
    }

    // --- min/max ---
    if (minBet > 0 && betAmount < minBet) {
      this.turboHold = false;
      store.dispatch(
        setPopupMessage({
          message: `${translate("min_bet_amount_is")} ${minBet} ${currency}`,
          delay: 4000,
        })
      );
      return;
    }

    if (maxBet > 0 && betAmount > maxBet) {
      this.turboHold = false;
      store.dispatch(
        setPopupMessage({
          message: `${translate("max_bet_is")} ${maxBet} ${currency}`,
          delay: 4000,
        })
      );
      return;
    }

    // --- turbo budget guard (remaining turbo value) ---
    const betMinor = toMinor(betAmount);
    const valueMinor = toMinor(Number(value) || 0);

    // 1) Turbo balance = 0 → end tek kad nema live lopti (inače sačekaj)
    if (valueMinor <= 0) {
      const live = this._getLiveCountForTicket(ticketId);

      if (live <= 0) {
        this._requestTurboCashout(ticketId, { silent: true });
      } else {
        this._schedulePendingTurboEnd(ticketId);
      }
      return;
    }

    // 2) Turbo balance < betAmount → poruka "bet too large", bez cashout-a
    if (betMinor > valueMinor) {
      this.turboHold = false;
      this._clearTurboWatchdog();
      this._clearTurboRateTimer();
      store.dispatch(
        setPopupMessage({
          message:
            translate("bet_too_large_top_up_turbo_balance") ||
            "Bet too large — top up your Turbo balance!",
          delay: 3500,
        })
      );
      return;
    }

    // --- rate limiting za turbo_bet_item (min interval između SEND-ova) ---
    // Napomena: turboPending već garantuje da se čeka odgovor/ACK za prethodni item.
    // Tako da je realni interval: max(ACK vreme, turbo_bet_speed_limit).
    const limitMs = Number(this.turboBetSpeedLimitMs) || 0;
    if (limitMs > 0) {
      const now = Date.now();
      const elapsed = now - (this.lastTurboItemSentAt || 0);

      // ako je poslednji send bio skoro, odloži sledeći pokušaj
      if (this.lastTurboItemSentAt && elapsed < limitMs) {
        const wait = Math.max(0, limitMs - elapsed);

        // ne zakazuj više puta
        if (!this.turboRateTimer) {
          this.turboRateTimer = setTimeout(() => {
            this.turboRateTimer = null;
            this._tryTurboNext();
          }, wait);
        }
        return;
      }
    }

    // --- pošalji turbo_bet_item ---
    // IMPORTANT: označi pending PRE slanja, da ne može dupli send pre ack-a
    this.turboPending = true;

    // zapamti vreme slanja (rate limit se odnosi na SEND-ove; ACK se čeka preko turboPending)
    this.lastTurboItemSentAt = Date.now();

    store.dispatch({
      type: "WEBSOCKET_SEND",
      payload: [
        "turbo_bet_item",
        {
          sid,
          isAutobet: 0,
          betAmount: String(betAmount), // sigurnije: šaljemo normalizovan broj
          ticketId,
          rows,
          level,
        },
      ],
    });

    this._armTurboWatchdog(5000);
  }

  // sabiranje u centima (minor) radi izbegavanja floating repova
  _addMinor(deltaMinor) {
    const val = fromMinor(deltaMinor); // vrati decimalu bez repova
    store.dispatch(addToBalance(val));
  }

  // === PRIVATE: ako su ACK i BALL_DONE prisutni, primeni win i skloni pending ===
  _settleIfReady(ticketId) {
    const st = store.getState();
    const item = st.pendingBets.byId[ticketId];
    if (!item) return;

    const ready = item.hasAck && item.hasBallDone && item.winAmount != null;
    if (ready) {
      const winMinor = toMinor(Number(item.winAmount) || 0);
      const before = st.balance.balance;
      tlog("SETTLE start (+win)", { ticketId, win: fromMinor(winMinor), beforeClientBalance: before });
      this._addMinor(winMinor);
      store.dispatch(removePending({ ticketId }));
      const after = store.getState().balance.balance;
      tlog("SETTLE done (+win)", { ticketId, afterClientBalance: after });
    }
  }

  // === Canvas: pozovi kad lopta padne ===
  ballDone(ticketId) {
    // ticketId iz UI:
    //  - turbo: "127258:3"
    //  - klasičan: broj (npr. 127258)

    const tidStr = String(ticketId);
    this.dlog("BALL_DONE recv", { ticketId: tidStr });

    // TURBO grana (UID sa ':')
    if (tidStr.includes(":")) {
      const tId = this._uidToTicketId(tidStr);
      // ako je ticket cashout-ovan na BE → ignoriši win i očisti eventualni pending
      if (Number.isFinite(tId) && this.cashedOutTickets.has(tId)) {
        this.pendingTurboWins.delete(tidStr);
        this.dlog("BALL_DONE ignored (cashed out)", { uid: tidStr, ticketId: tId });

        // NEW: i dalje obeleži da je lopta završila (da pending end može da se odradi)
        this._markTurboBallDone(tidStr);
        return;
      }

      // 1) pokušaj da nađeš win
      const has = this.pendingTurboWins.has(tidStr);
      if (has) {
        const win = Number(this.pendingTurboWins.get(tidStr)) || 0;
        this.pendingTurboWins.delete(tidStr);
        if (win > 0) {
          this.dlog("APPLY WIN", { uid: tidStr, win });
          store.dispatch(addToBalance(win)); // TEK sada uvećavamo balance
        } else {
          this.dlog("APPLY WIN skipped (win=0)", { uid: tidStr, win });
        }
        this.debugListTurboWins();
      } else {
        const all = this.debugListTurboWins();
        const prefix = tidStr.split(":")[0] + ":";
        const sameTicket = all.filter(e => e.uid.startsWith(prefix));
        this.dlog("WIN MISSING for UID", {
          uid: tidStr,
          hint_sameTicket: sameTicket,
          note: "Ako je lista prazna, UI ne šalje isti UID kao u turboBetItem (ticket_uid)."
        });
      }

      // NEW: lopta je završila (upala u džep)
      this._markTurboBallDone(tidStr);
      return;
    }

    // Klasična grana (bez UID-a): pendingBets flow
    store.dispatch(markBallDone({ ticketId: Number(tidStr) }));
    this._settleIfReady(Number(tidStr));
  }

  // === Login ===
  login(data) {
    console.log("Login data:", data);
    this.allowedTurboDrops.clear();
    this.cashedOutTickets.clear();
    this.pendingTurboWins.clear();
    this.turboCounters.clear();
    this.turboRestart = null;
    this.turboRestartForTicket = null;

    // NEW: reset end/live tracking
    this.pendingEndTicketId = null;
    this.liveTurboUids.clear();
    this.liveTurboCountByTicket.clear();

    // turbo rate limit (ms)
    const lim = Number(data?.turbo_bet_speed_limit);
    this.turboBetSpeedLimitMs = Number.isFinite(lim) && lim > 0 ? Math.floor(lim) : 0;

    // reset rate limiter state
    this.lastTurboItemSentAt = 0;
    this._clearTurboRateTimer();

    // 1) currency precision → minor factor
    setMinorFactorFromLogin(data);
    this.turboAutoCashoutPending = false;
    // 2) standard login state
    store.dispatch(setLoginData(data));
    store.dispatch(setInitialHitOdds(data?.player_ticket_history || []));

    // 3) RESUME turbo mode ako BE vrati otvorene tikete
    const open = Array.isArray(data?.open_tickets) ? data.open_tickets : [];

    if (open.length > 0) {
      // Turbo ticket prepoznajemo po turbo_bet (a ne po remaining_money)
      const t =
        open.find(o => o?.ticket_id != null && Number(o?.turbo_bet) > 0) ||
        open.find(o => o?.ticket_id != null) ||
        open[0];

      const ticketId = t?.ticket_id != null ? Number(t.ticket_id) : null;

      // remaining može biti 0 (npr. potrošeno, čeka da lopte upadnu)
      const remaining = Number(t?.remaining_money ?? 0);

      if (Number.isFinite(ticketId) && ticketId) {
        store.dispatch(
          setTurboMode({
            state: true,
            value: Number.isFinite(remaining) ? remaining : 0,
            ticketId,
          })
        );
      }
    }
    const tm = store.getState().turboMode;
    if (tm?.state) {
      setTimeout(() => this.getUserBalance(), 200);
    }
  }

  // === Balance push iz BE-a (ako ga koristiš u drugim porukama) ===
  balance(balance) {
    store.dispatch(setBalanceValue(balance));
  }

  getUserBalance() {
    const state = store.getState();
    const sid = state.login?.sid;
    store.dispatch({
      type: "WEBSOCKET_SEND",
      payload: ["get_user_balance", { sid }],
    });
  }

  // === Jackpot ===
  jackpot(jackpot) {
    store.dispatch(setJackpotValue(jackpot));
  }

  turboBetAck(payload) {
    if (payload?.bet_passed === true) {
      store.dispatch(setBalanceValue(payload.balance));

      // 1) uzmi vrednost koju smo planirali da kupimo
      const planned = this.nextTurboStartValue;
      this.nextTurboStartValue = null;

      // 2) fallback ako planned nije setovan (za svaki slučaj)
      const fallback =
        Number(payload?.remaining_money ?? payload?.value ?? payload?.bet ?? 0) || 0;

      store.dispatch(setTurboMode({
        value: planned != null ? planned : fallback,
        ticketId: payload.ticket_id,
        state: true,
      }));
    }
  }

  turboBetItem(payload) {
    // { bet_passed: true/false, id, itemId, ticket_id, total_win_money, win_money }

    // stigao odgovor → očisti watchdog/pending
    this._clearTurboWatchdog();
    this.turboPending = false;

    // ako BET NIJE PROŠAO — samo poruka (ne diramo value, ne triggujemo drop)
    if (payload?.bet_passed !== true) {
      const reason =
        payload?.reason ||
        payload?.message ||
        translate("bet_rejected") ||
        "Bet rejected.";
      store.dispatch(setPopupMessage({ message: reason, delay: 4000 }));
      this.dlog("ITEM REJECTED", { payload });
      return;
    }

    const st = store.getState();
    const betAmount = st.betAmount;
    const { ticketId, value } = st.turboMode || {};

    // zaštita: ako payload nije za aktivni ticket
    if (ticketId && payload?.ticket_id && Number(payload.ticket_id) !== Number(ticketId)) {
      this.dlog("IGNORED ITEM (different ticket)", { activeTicket: ticketId, payloadTicket: payload?.ticket_id });
      return;
    }

    // umanji turbo value
    const nextMinor = Math.max(0, toMinor(value) - toMinor(betAmount));
    const nextValue = fromMinor(nextMinor);

    store.dispatch(setTurboMode({
      value: nextValue,
      ticketId: ticketId ?? payload?.ticket_id ?? null,
      state: true,
    }));

    // generiši stabilan UID: "ticketId:seq"
    if (payload?.ticket_id != null && payload?.id != null) {
      const tIdNum = Number(payload.ticket_id);

      // ako je ticket već cashout-ovan, ne beležimo win i ne trigger-ujemo drop
      if (Number.isFinite(tIdNum) && this.cashedOutTickets.has(tIdNum)) {
        this.dlog("ITEM IGNORED (ticket cashed out)", { ticketId: tIdNum });
        return;
      }

      const last = this.turboCounters.get(tIdNum) || 0;
      const seq  = last + 1;
      this.turboCounters.set(tIdNum, seq);

      const ticketUid = `${tIdNum}:${seq}`;

      // NEW: označi ovu loptu kao "live" (na stolu) dok ne stigne ballDone
      this._markTurboBallLive(ticketUid);

      this.allowTurboDrop(ticketUid);

      // zapamti win za ovaj UID (dodaćemo ga tek u ballDone)
      const winNow = Number(payload?.win_money ?? 0) || 0;
      if (winNow > 0) {
        this.pendingTurboWins.set(ticketUid, winNow);
        this.dlog("STORE WIN", { uid: ticketUid, win: winNow });
      } else {
        this.dlog("STORE WIN (zero/none)", { uid: ticketUid, win: winNow });
      }

      // UI slot index mora biti 0..(levels) tj. 0..numberOfRows (slotCount = numberOfRows + 1)
      const rowsNow = Number(store.getState()?.numberOfRows ?? st?.numberOfRows ?? 8);
      const maxSlot = Number.isFinite(rowsNow) && rowsNow >= 1 ? rowsNow : 8;
      const slotCount = maxSlot + 1;

      let uiSlot = Number(payload?.id);

      // ako id nije validan za trenutni broj slotova, radi fallback
      if (!Number.isFinite(uiSlot) || uiSlot < 0 || uiSlot > maxSlot) {
        const fallbackBase = Number(payload?.itemId ?? payload?.item_id ?? payload?.sub_id ?? 0);
        uiSlot = Number.isFinite(fallbackBase)
          ? (Math.abs(fallbackBase) % slotCount)
          : Math.floor(Math.random() * slotCount);
      }

      if (Number(payload?.id) !== uiSlot) {
        this.dlog("TURBO uiSlot fallback", { payloadId: payload?.id, itemId: payload?.itemId, uiSlot });
      }

      // trigger drop sa TAČNO tim UID-om (isto će stići u ballDone)
      store.dispatch(setActiveBet({
        bet_passed: true,
        id: uiSlot,             // <<< BITNO: sada je uvek 0..8
        ticket_uid: ticketUid,
        isTurboItem: true,
      }));

      // dodatno: zabeleži stanje posle store-a
      this.debugListTurboWins();
    } else {
      this.dlog("MISSING FIELDS for turbo item", { payload });
    }

    // auto-nastavak
    if (this.turboHold) {
      this._tryTurboNext();
    }
  }

  turboCashout(payload) {
    const ticketIdNum = Number(payload?.ticket_id);
    if (!Number.isFinite(ticketIdNum)) return;
    this.turboAutoCashoutPending = false;

    // NEW: ako smo čekali "end after balls", očisti pending
    if (this.pendingEndTicketId != null && Number(this.pendingEndTicketId) === Number(ticketIdNum)) {
      this.pendingEndTicketId = null;
    }
    this.liveTurboCountByTicket.delete(ticketIdNum);

    this.clearTurboDropsForTicket(ticketIdNum);
    this._clearTurboRateTimer();

    // 0) označi ticket kao cashout-ovan i očisti pending
    this.cashedOutTickets.add(ticketIdNum);
    this._clearPendingWinsForTicket(ticketIdNum);

    // 1) zaustavi turbo hold/pending
    this.turboHold = false;
    this.turboPending = false;

    // 2) resetuj turbo mode
    store.dispatch(setTurboMode({
      value: 0,
      ticketId: null,
      state: false,
    }));

    // 3) zatvori turbo modal
    store.dispatch(setTurboModeModal({ state: false }));

    // 3.1) RESTART ako je tražen (START dok je turbo bio aktivan)
    const shouldRestart =
      this.turboRestart &&
      Number.isFinite(this.turboRestartForTicket) &&
      Number(this.turboRestartForTicket) === Number(ticketIdNum);

    if (shouldRestart) {
      const st = store.getState();
      const sid = st.login?.sid;

      const betAmount = this.turboRestart.betAmount;
      const rows = this.turboRestart.rows ?? st.numberOfRows;
      const level = this.turboRestart.level ?? gameDifficultyConverter(st.gameDifficulty);

      // >>> DODAJ OVO (cashout poruka i kad restartuje)
      const winMinor = toMinor(payload?.win || 0);
      const winRounded = fromMinor(winMinor);
      const currency = store.getState().login?.player_data?.currency_code?.CurrencyID || "";

      store.dispatch(setPopupMessage({
        message: `${translate("cashout_success") || "Cashout successful"} — ${translate("you_won") || "you won"} ${winRounded.toFixed(2)} ${currency}!`,
        delay: 3500, // po želji kraće kad je auto-restart
      }));
      soundFxPlayer.play("cashout")
      // <<<

      // očisti request pre slanja (da ne duplira)
      this.turboRestart = null;
      this.turboRestartForTicket = null;

      if (sid && betAmount) {
        store.dispatch({
          type: "WEBSOCKET_SEND",
          payload: [
            "placed_bet",
            {
              sid,
              betAmount,
              isAutobet: false,
              rows,
              level,
              isTurbo: true,
            },
          ],
        });
      }

      setTimeout(() => this.getUserBalance(), 800);
      return;
    }

    // --- normalan cashout (bez restart-a) ---
    const winMinor = toMinor(payload?.win || 0);
    const winRounded = fromMinor(winMinor);
    const currency = store.getState().login?.player_data?.currency_code?.CurrencyID || "";

    store.dispatch(setPopupMessage({
      message: `${translate("cashout_success") || "Cashout successful"} — ${translate("you_won") || "you won"} ${winRounded.toFixed(2)} ${currency}!`,
      delay: 6000,
    }));
    soundFxPlayer.play("cashout")

    setTimeout(() => this.getUserBalance(), 800);
  }

  // === BET ACK (glavna tačka za paralelne betove) ===
  betAck(payload) {
    // payload: { balance, bet, bet_passed, id, ticket_id, win }
    const ticketId = Number(payload.ticket_id);
    const winAmount = Number(payload.win);

    const betAmount = Number(payload.bet) || 0;
    const betMinor = toMinor(betAmount);

    const before = store.getState().balance.balance;
    tlog("ACK in", { ticketId, id: payload.id, bet_passed: payload.bet_passed, win: winAmount, ackBalance: payload.balance, beforeClientBalance: before });

    if (payload?.bet_passed === false) {
      store.dispatch(
        upsertFromAck({
          ticketId,
          winAmount: 0,
          meta: {
            wsId: payload.id,
            bet: Number(payload.bet),
            bet_passed: false,
            serverBalanceAtAck: Number(payload.balance),
          },
        })
      );
      // nema win-a, očisti pending
      store.dispatch(removePending({ ticketId }));

      const after = store.getState().balance.balance;
      tlog("ACK applied (bet_passed=false)", { afterClientBalance: after });
      return;
    }

    // bet_passed === true
    store.dispatch(
      upsertFromAck({
        ticketId,
        winAmount,
        meta: {
          wsId: payload.id,
          bet: Number(payload.bet),
          bet_passed: true,
          serverBalanceAtAck: Number(payload.balance),
        },
      })
    );

    // odmah prikaži server balance sa skinutim bet-om
    this._addMinor(-betMinor);

    // Event za spuštanje lopte (da GamePlay pozove dropBall)
    const rowsNow = Number(store.getState()?.numberOfRows ?? 8);
    const maxSlot = Number.isFinite(rowsNow) && rowsNow >= 1 ? rowsNow : 8;

    let uiSlot = Number(payload.id);
    if (!Number.isFinite(uiSlot)) uiSlot = 0;

    // ako server ikad pošalje out-of-range (ili promeni format), nemoj da puca animacija
    if (uiSlot < 0) uiSlot = 0;
    if (uiSlot > maxSlot) uiSlot = maxSlot;

    store.dispatch(
      setActiveBet({
        bet_passed: true,
        id: uiSlot,
        ticket_id: ticketId,
      })
    );

    // Ako je ball_done došao pre ACK-a, ovo će dodati win i očistiti pending
    this._settleIfReady(ticketId);
  }

  // === Bonus rounds expired ===
  bonusExpired(value) {
    if (!value) return;

    if (store.getState().freeBet) {
      store.dispatch(
        setFreeTicketInfo({
          ...store.getState().freeTicketInfo,
          freeTicketCount: 1,
        })
      );
    } else {
      store.dispatch(toggleFreeBetsState(false));
      setsProperBonusLabel(false);
      store.dispatch(
        setFreeTicketInfo({
          noOfRounds: 0,
          value: 0,
          currency: "",
          freeTicketCount: 0,
          validUntil: null,
        })
      );
      store.dispatch(setAlreadyShownBonusModal(false));
    }
  }

  // === Cashout ack (ako više ne koristiš, slobodno ukloni ceo metod i import) ===
  cashoutAck(data) {
    store.dispatch(setCashout(data));
    if (data?.win) {
      this.getUserBalance();
    }
  }

  // === Ostale util poruke ===
  playerException(data) {
    if (data) {
      // Prikaži poruku
      store.dispatch(setPopupMessage({ delay: 5000, message: data }));

      // Ako smo usred turbo item-a i stigla je greška, oslobodi pending i prekini burst
      if (this.turboPending) {
        this._clearTurboWatchdog();
        this._clearTurboRateTimer();
        this.turboPending = false;
        this.turboHold = false; // prekini trenutni “hold”; korisnik može ponovo da pritisne
      }
    }
  }

  sessionStatus(data) {
    if (data) {
      store.dispatch(setServerMessage(data));
    }
  }

  betHistory(data) {
    if (Array.isArray(data)) {
      store.dispatch(setBetHistoryList(data));
    }
  }

  // === Free tickets ===
  freeTickets(data) {
    const parts = data?.message?.MessageText?.split(";") || [];
    const bonusRounds = Number(parts[0] ?? 0);
    const amountAndCurrency = (parts[1] ?? "").split(" ");
    const amount = parseFloat(amountAndCurrency[0] ?? "0");
    const currency = amountAndCurrency[1] ?? "";
    const timestamp =
      parts.length === 3 && /\d/.test((parts[2] ?? "").trim())
        ? (parts[2] ?? "").trim()
        : null;

    if (shouldShowBonusModal(currency)) {
      store.dispatch(
        setBounsRoundsModal({
          show: true,
          noOfRounds: bonusRounds,
          validUntil: timestamp,
          value: amount,
          currency,
          alreadyShown: false,
        })
      );
    }
  }
}

const plinkoTransport = new PlinkoTransport();
export default plinkoTransport;
